//window.addEventListener('load', function(){

var slick_options = {
  rows: 0,
  infinite: false,
  adaptiveHeight: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:
    "<div class=&apos;slick-prev slick-arrow slick-arrow--large&apos;><svg class=&apos;icon&apos;><use href=&apos;#icon-chevron-left&apos; /></svg></div>",
  nextArrow:
    "<div class=&apos;slick-next slick-arrow slick-arrow--large&apos;><svg class=&apos;icon&apos;><g><g><polygon points='131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></div>",
};
//initialize straps in case not initialized (FF)
setTimeout(function () {
  if (!$(".straps-slider").hasClass("slick-initialized")) {
    $(".straps-slider").slick(slick_options);
    //uncheck if input checked
    if ($('.straps-slider .check-radio input[type="radio"]:checked').length > 0)
      $('.straps-slider .check-radio input[type="radio"]:checked').prop(
        "checked",
        false
      );
  }
}, 500);

var money_format = "€_money_",
  product_selections = ["case_product", "straps_product"],
  footer_element = document.querySelectorAll(".config-actions"),
  some_product_unavailable = false,
  buttons = document.querySelectorAll(".ProductForm__AddToCart"),
  straps_image_used = false,
  case_temaplte =
    '<div class="Carousel__Cell check-radio" data-case-slider="__id__">' +
    '<input type="radio" name="case_product" id="__id__" value="__id__" class="input-hidden" data-index="__index__">' +
    '<label for="__id__" class="border-radius config-item">' +
    '<div class="item">' +
    '<img src="__image__" >' +
    "</div>" +
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="29" height="29" viewBox="0 0 29 29"><defs><style>.a1{fill:#fff;}.b1{fill:#f08584;}.c1{clip-path:url(#a);}</style><clipPath id="a1"><path class="a1" d="M0,0H14.135V-12.155H0Z"></path></clipPath></defs><g transform="translate(-131 -604)"><circle class="b1" cx="14.5" cy="14.5" r="14.5" transform="translate(131 633) rotate(-90)"></circle><g class="c1" transform="translate(139 624.31)"><g transform="translate(5.412 -0.234)"><path class="a1" d="M0,0A.687.687,0,0,1-.51.234.685.685,0,0,1-1.02,0L-5.095-4.514a1.291,1.291,0,0,1,0-1.7l.51-.565a1.01,1.01,0,0,1,1.531,0L-.51-3.956,6.364-11.57a1.01,1.01,0,0,1,1.531,0l.51.565a1.292,1.292,0,0,1,0,1.7Z"></path></g></g></g></svg>' +
    "</label></div>";

var magsafeCheckbox = document.getElementById("magsafe");
var displayCoverCheckbox = document.getElementById("displaycover");

function handleButtonsText() {
  for (var i = 0; i < buttons.length; i++) {
    if (some_product_unavailable) {
      buttons[i].querySelector("span").innerText = "Ausverkauft";
      buttons[i].setAttribute("disabled", true);
    } else {
      buttons[i].querySelector("span").innerText = "Zum Warenkorb hinzufügen";
      buttons[i].removeAttribute("disabled");
    }
  }
}
function addClass(element, c) {
  if (!element) return;
  if (element.className.indexOf(c) == -1) {
    element.className += " " + c;
  }
}
function removeClass(element, c) {
  if (!element) return;
  if (element.className.indexOf(c) > -1) {
    if (element.className.indexOf(" " + c) > -1)
      element.className = element.className.replace(" " + c, "");
    else element.className = element.className.replace(c, "");
  }
}
function fireResize() {
  var resizeEvent = window.document.createEvent("UIEvents");
  resizeEvent.initUIEvent("resize", true, false, window, 0);
  window.dispatchEvent(resizeEvent);
}
fireResize();
setTimeout(function () {
  fireResize();
});
const handleColorChange = (e) => {
  document.querySelector(".label-color-selected").innerText = e.target.value;
  updateURL('strapColor', e.target.value)
  mobile_bundle_products_selected.color = e.target.value;
  updateStrapSliderImage(mobile_bundle_products_selected.color);
  var straps_product_index = document.querySelector('input[name="straps_product"]:checked');
  if(straps_product_index != null)
  {
    var straps_product_index = document.querySelector('input[name="straps_product"]:checked').getAttribute("data-index");
    updateImage("straps", straps_product_index);
    
  }
  checkSizeAvailable();
  document.dispatchEvent(new CustomEvent("configurator-image-update"));

   var straps_size_variants = mobile_bundle_products_selected.straps.variants.filter(
    function (obj) {
      return (
        obj[mobile_bundle_products_selected.color_option] ==
          mobile_bundle_products_selected.color && obj.available
      );
    }
  );



  if (straps_size_variants.length == 1) {
    removeClass(document.querySelector(".size-optios"), "unavailable");
    addClass(
      document.querySelector(".size-optios"),
      "partial only-" +
        straps_size_variants[0][mobile_bundle_products_selected.size_option]
    );
    //select the available already ( check ) updated today
    
      $('label[for="' +
          straps_size_variants[0][mobile_bundle_products_selected.size_option] +
          '"]').parent().find('img').trigger('click');
  } else {
    document.querySelector(".size-optios").className =
      "selector-wrapper size-optios";
  }
}
function updateStrapSliderImage(color)
  {
    var new_src = "";
    $('.strap-slider-image').each(function(){
      if(color == "silver" || color == "silber" || color == "Silber" || color == "Silver")
      {
        new_src = $(this).attr('data-silver-image');
      }
      else 
      {
        new_src = $(this).attr('data-gold-image');
      }
      if(new_src != "")
      {
        $(this).attr("src",new_src);
      }
    });
  }
function handleShowHideMagsafe(model, isChecked) {
  var magsafeWrapper = document.querySelector(".magsafe-wrapper"); // get the checkbox wrapper
  magsafeCheckbox.checked = false;
  // so we only want to show the magsafe checkbox if we have a magsafe product
  // Get the selected product name
  const productTitle =
    mobile_bundle_products_selected.case.title.split(" - ")[0]; // Get only the name before " - "
  
  // Create the Magsafe version of the product name
  var magsafeVersionName = productTitle + " - MagSafe Handyhülle";

  // Check if a product with the Magsafe version name exists
  var magsafeProduct = magsafeCasesProducts.find(
    (product) => product.title === magsafeVersionName
  );
  // If a Magsafe version of the product exists, check if the model variant is available
  if (isChecked && magsafeProduct) {
    var modelVariantExists = magsafeProduct.variants.some(
      (variant) => variant.options[0].includes(model) && variant.available
    );
    if (modelVariantExists) {
      magsafeWrapper.style.display = "block";
    } else {
      magsafeWrapper.style.display = "none";
    }
  } else {
    magsafeWrapper.style.display = "none";
  }
}

function handleShowHideDisplayCover(isChecked) {
  var displaycoverWrapper = document.querySelector(".displaycover-wrapper"); // get the checkbox wrapper
  displayCoverCheckbox.checked = false;
  // so we only want to show the displaycover checkbox if we have a displaycover product
  // Get the selected product name
  const productTitle =$('#product-select-').val();
  
  
  // Create the Magsafe version of the product name
  var displayCoverVersionName = "Panzerglas (2er Set) - " + productTitle;
  // Check if a product with the Magsafe version name exists
  var displayCoverProduct = displayCoverProducts.find(
    (product) => product.title === displayCoverVersionName
  );
  // If a displaycover version of the product exists, check if the model variant is available
  if (isChecked && displayCoverProduct) {
    var modelVariantExists = displayCoverProduct.variants[0].available;
    //var modelVariantExists = true;

    if (modelVariantExists) {
      displaycoverWrapper.style.display = "block";
    } else {
      displaycoverWrapper.style.display = "none";
    }
  } else {
    displaycoverWrapper.style.display = "none";
  }
}
function getSelectedProductIndex(container, variantId, selector = 'data-case-slider') {
    const sliderContainer = document.querySelector(container);
    const targetElement = sliderContainer.querySelector(`[${selector}="${variantId}"]`);
    const allChildren = Array.from(sliderContainer.children);
    return allChildren.indexOf(targetElement);
}
// let's use this function get our URL params
function getUrlParameters() {
    const params = {};
    const urlParams = new URLSearchParams(window.location.search);
    
    // For the phone model
    if (urlParams.has('phoneModel')) {
        params.phoneModel = urlParams.get('phoneModel');
        const encodedModel = decodeURIComponent(params.phoneModel);

        setAndTriggerModelChange(params.phoneModel);
    }

    // For the case color
    if (urlParams.has('case')) {
        params.case = urlParams.get('case');
        const selectedCaseIndex = mobile_bundle_products.case.findIndex(product => product.id === Number(params.case));
        console.log('index for case is ', selectedCaseIndex)
        if (selectedCaseIndex !== -1) {
            // build an event object
             const mockEvent = {
                  target: {
                      id: params.case,
                      dataset: {
                          index: selectedCaseIndex,
                          productIndex: 0
                      },
                      value: "Some value"  // Adjust this if needed
                  }
              };
                          // Call the changeHandler for the case
            changeHandler(mockEvent, "case_product");
            // scroll case into view
            let index = getSelectedProductIndex('.case-slider .flickity-slider', params.case)
             // since we need to select the model above we got to wait for the element to be available in the DOM
             setTimeout(() => {
               $('.case-slider').flickity( 'select', index, false, false )
               // set selected to true
               const radioInput = document.getElementById(params.case);
               radioInput.checked = true
             }, 500)
          }
    }

    // For the strap model
    if (urlParams.has('strapModel')) {
       params.strapModel = urlParams.get('strapModel');
       const selectedStrapIndex = mobile_bundle_products.straps.findIndex(product => product.id === Number(params.strapModel));
      if (selectedStrapIndex !== -1) {
        // build an event object
             const mockEvent = {
                  target: {
                      id: params.strapModel,
                      dataset: {
                          index: selectedStrapIndex,
                          productIndex: 0
                      },
                      value: "Some value"  // Adjust this if needed
                  }
              };
        changeHandler(mockEvent, "straps_product");
        // scroll strap into view
       let index = getSelectedProductIndex('.straps-new-slider .flickity-slider', params.strapModel, 'data-straps-id')
        $('.straps-new-slider').flickity( 'select', index, false, false )
               // set selected to true
               const radioInput = document.getElementById(params.strapModel);
               radioInput.checked = true
      }
        
    }

    // For the strap color
    if (urlParams.has('strapColor')) {
        params.strapColor = urlParams.get('strapColor');
        // Create a mock event object and pass it to handleColorChange
        const mockEvent = {
          target: {
            value: params.strapColor
          }
        };
        
        handleColorChange(mockEvent);
        // Set the correct radio option based on strapColor value
        document.querySelectorAll('.swatch-element.color').forEach(element => {
            let inputValue = element.querySelector('input[type="radio"]').value;
            if (inputValue === params.strapColor) {
                element.querySelector('input[type="radio"]').checked = true;
            } else {
                element.querySelector('input[type="radio"]').checked = false;
            }
        });
    }
  
    return params;
}


function updateURL(paramName, paramValue) {
    const currentURL = new URL(window.location.href);
    currentURL.searchParams.set(paramName, paramValue);
    window.history.pushState({ path: currentURL.toString() }, '', currentURL.toString());
}

getUrlParameters()
// we use the value from the URL here to set the select value
function setAndTriggerModelChange(value) {
  const model_select = document.querySelectorAll(".model-select select");
  // Set the value of the select element
  model_select[0].value = value;

  // Create and dispatch the change event
  renderAvailableCases(value);
  checkAvailability(value);
}

function renderAvailableCases(model) {
  var unavailable_cases = [];
  for (var i = 0; i < mobile_bundle_products.case.length; i++) {
    var available_case_model = mobile_bundle_products.case[i].variants.filter(
      function (obj) {
        return obj.option1 == model && obj.available;
      }
    );
    if (available_case_model.length == 0) unavailable_cases.push(i);
  }
  var template_html = "";

  //remove all by default
  if ($(".case-slider").hasClass("slick-initialized")) {
    $(".case-slider").slick("unslick");
  }
  jQuery(".slider1.case-slider").flickity("destroy");

  if (unavailable_cases.length == mobile_bundle_products.case.length) {
    document.querySelector(".case-slider").innerHTML =
      "<p>" + window.configurator.nocase + "</p>";
    return;
  }

  if (unavailable_cases.length > 0) {
    for (var i = 0; i < mobile_bundle_products.case.length; i++) {
      if (unavailable_cases.indexOf(i) == -1) {
        var temp = case_temaplte;
        p = mobile_bundle_products.case[i];
        temp = temp.replace(/__id__/g, p.id);
        temp = temp.replace(/__index__/g, i);
        temp = temp.replace(/__image__/g, p.featured_image);
        // $('.case-slider').slick('slickAdd', (temp))
        // console.log('template_html ', JSON.stringify(temp) )
        template_html += temp;
      }
    }
  } else {
    for (var i = 0; i < mobile_bundle_products.case.length; i++) {
      var temp = case_temaplte;
      p = mobile_bundle_products.case[i];
      temp = temp.replace(/__id__/g, p.id);
      temp = temp.replace(/__index__/g, i);
      temp = temp.replace(/__image__/g, p.featured_image);
      template_html += temp;
    }
  }
  document.querySelector(".case-slider").innerHTML = template_html;
  jQuery(".slider1.case-slider").flickity({
    freeScroll: true,
    fullscreen: true,
    contain: true,
    cellAlign: "left",
    pageDots: false,
  });
  fireResize();

  //rebind change events to new dom
  var radio_group = document.querySelectorAll('input[name="case_product"]');
  var magsafeWrapper = document.querySelector(".magsafe-wrapper"); // get the checkbox wrapper
  magsafeWrapper.style.display = "none";
  for (var j = 0; j < radio_group.length; j++) {
    radio_group[j].addEventListener("change", function (e) {
      changeHandler(e, "case_product");
      handleShowHideMagsafe(model, this.checked )
    });
  }

  var displayCoverWrapper = document.querySelector(".displaycover-wrapper"); // get the checkbox wrapper
  displayCoverWrapper.style.display = "none";
  for (var j = 0; j < radio_group.length; j++) {
    radio_group[j].addEventListener("change", function (e) {
      changeHandler(e, "case_product");
      handleShowHideDisplayCover(this.checked )
    });
  }
  console.log("unavailable_cases ", unavailable_cases);

   
}

function checkSizeAvailable() {
  straps_size_variants = mobile_bundle_products_selected.straps.variants.filter(
    function (obj) {
      return (
        obj[mobile_bundle_products_selected.color_option] ==
          mobile_bundle_products_selected.color && obj.available
      );
    }
  );
  //    console.log('straps_size_variants ', straps_size_variants);
  var color_options = document.querySelectorAll(
    ".options_bundle .swatch-element"
  );
  color_options.forEach(function (swatch) {
    removeClass(swatch, "soldout");
  });

  var last_color = null,
    atleastoneout = false,
    visited_colors = [];
  mobile_bundle_products_selected.straps.variants.forEach(function (variant_) {
    var last_color = variant_[mobile_bundle_products_selected.color_option];
    if (visited_colors.length == 0) {
      //first

      color_variants = mobile_bundle_products_selected.straps.variants.filter(
        function (obj) {
          return (
            obj[mobile_bundle_products_selected.color_option] == last_color &&
            obj.available
          );
        }
      );
      //console.log('color_variants ', color_variants)
      if (color_variants.length == 0) {
        addClass(
          document.querySelector(
            '.options_bundle .swatch-element[data-value="' + last_color + '"]'
          ),
          "soldout"
        );
        atleastoneout = true;
      }
      visited_colors.push(last_color);
    } else if (visited_colors.indexOf(last_color) > -1) {
      //second time -- only check

      color_variants = mobile_bundle_products_selected.straps.variants.filter(
        function (obj) {
          return (
            obj[mobile_bundle_products_selected.color_option] == last_color &&
            obj.available
          );
        }
      );
      //console.log('color_variants ', color_variants)
      if (color_variants.length == 0) {
        addClass(
          document.querySelector(
            '.options_bundle .swatch-element[data-value="' + last_color + '"]'
          ),
          "soldout"
        );
        atleastoneout = true;
      }
    } else {
      //new
      visited_colors.push(last_color);
    }
  });

  //if there is one or more color left click the first available
  if (atleastoneout) {
    document
      .querySelector(".options_bundle .swatch-element:not(.soldout) label")
      .click();
  }

  if (straps_size_variants.length == 1) {
    removeClass(document.querySelector(".size-optios"), "unavailable");
    addClass(
      document.querySelector(".size-optios"),
      "partial only-" +
        straps_size_variants[0][mobile_bundle_products_selected.size_option]
    );
    //select the available already ( check ) updated today
    
      $('label[for="' +
          straps_size_variants[0][mobile_bundle_products_selected.size_option] +
          '"]').parent().find('').trigger('click');
  } else {
    document.querySelector(".size-optios").className =
      "selector-wrapper size-optios";
  }
}

function checkAvailability(model_) {
  if (model_ != "") {
    addClass(document.querySelector(".Product__Wrapper2"), "model-selected");
  } else {
    removeClass(document.querySelector(".Product__Wrapper2"), "model-selected");
  }

  if (document.querySelector(".ProductForm__Error") != null)
    document.querySelectorAll(".ProductForm__Error").forEach(function (e) {
      e.remove();
    });

  var case_variant = null,
    straps_variant = null;
  if (mobile_bundle_products_selected.case) {
    case_variant = mobile_bundle_products_selected.case.variants.filter(
      function (obj) {
        return obj.option1 == model_;
      }
    )[0];
    addClass(document.querySelector(".Product__Wrapper2"), "case-selected");
    
  }

  if (mobile_bundle_products_selected.straps) {
    straps_variant = mobile_bundle_products_selected.straps.variants.filter(
      function (obj) {
        return (
          obj[mobile_bundle_products_selected.color_option] ==
            mobile_bundle_products_selected.color &&
          obj[mobile_bundle_products_selected.size_option] ==
            mobile_bundle_products_selected.size
        );
      }
    )[0];
    //check size available
    checkSizeAvailable();
    
    addClass(document.querySelector(".Product__Wrapper2"), "straps-selected");
  }
  // $('.straps-slider').slick('refresh');
  // fireResize();

  if (
    (case_variant && !case_variant.available) ||
    (straps_variant && !straps_variant.available)
  ) {
    footer_element.forEach(function (e) {
      var errorMessageElement = document.createElement("span");
      errorMessageElement.className =
        "ProductForm__Error Alert Alert--error logic-alert";
      errorMessageElement.innerHTML =
        "Achtung: Deine Konfiguration hat sich geändert, da das gewählte Produkt ausverkauft ist!";
      e.insertAdjacentElement("afterend", errorMessageElement);
    });
    return;
  }
}
function changeHandler(event, selector) {
  var product_type = selector.split("_")[0];
  var index = event.target.dataset["index"];
  var pindex = event.target.dataset["productIndex"];
  //console.log(event.target.value, product_type,pindex, mobile_bundle_products[product_type][pindex]);

  if (product_type == "case") {
    const variantId = event.target.id
    updateURL('case', variantId)
    mobile_bundle_products_selected[product_type] =
      mobile_bundle_products[product_type][index];
  } else {
    //for straps
    
    const variantId = event.target.id
    updateURL('strapModel', variantId)
    mobile_bundle_products_selected[product_type] =
      mobile_bundle_products[product_type][index];

    var straps_size_variants = mobile_bundle_products_selected.straps.variants.filter(
    function (obj) {
      return (
        obj[mobile_bundle_products_selected.color_option] ==
          mobile_bundle_products_selected.color && obj.available
      );
    }
  );



  if (straps_size_variants.length == 1) {
    removeClass(document.querySelector(".size-optios"), "unavailable");
    addClass(
      document.querySelector(".size-optios"),
      "partial only-" +
        straps_size_variants[0][mobile_bundle_products_selected.size_option]
    );
    //select the available already ( check ) updated today
    
      $('label[for="' +
          straps_size_variants[0][mobile_bundle_products_selected.size_option] +
          '"]').parent().find('img').trigger('click');
  } else {
    document.querySelector(".size-optios").className =
      "selector-wrapper size-optios";
  }
  
  }

  handleButtonsText();
  handleProductsChange(product_type, selector, index, pindex);

  
}

function updateImage(product_type, index) {
  var img_src = "";
  if (product_type == "case") {
    img_src = mobile_bundle_products.case_images[index];
    if (straps_image_used) {
      straps_image_used = false;
      var straps_product_index = document.querySelector(
        'input[name="straps_product"]:checked'
      ).dataset.index;
      document
        .querySelector(".mobile-straps")
        .setAttribute(
          "src",
          mobile_bundle_products.straps_images[
            mobile_bundle_products_selected.color.toLowerCase()
          ][straps_product_index]
        );
    }
  } else {
    if (mobile_bundle_products_selected.case == null) {
      straps_image_used = true;
      straps_variant = mobile_bundle_products_selected.straps.variants.filter(
        function (obj) {
          return (
            obj[mobile_bundle_products_selected.color_option] ==
              mobile_bundle_products_selected.color &&
            obj[mobile_bundle_products_selected.size_option] ==
              mobile_bundle_products_selected.size
          );
        }
      )[0];
      if (straps_variant.featured_image)
        img_src = straps_variant.featured_image;
      else {
        if(mobile_bundle_products_selected.color.toLowerCase() == "silber" || mobile_bundle_products_selected.color.toLowerCase() == "silver")
        {
          img_src = mobile_bundle_products_selected.straps.images[2];
        }
        else 
        {
          img_src = mobile_bundle_products_selected.straps.images[0];
          
        }
      }
    } else {
      straps_image_used = false;
      img_src =
        mobile_bundle_products.straps_images[
          mobile_bundle_products_selected.color.toLowerCase()
        ][index];
    }
  }
  document
    .querySelector(".mobile-" + product_type)
    .setAttribute("src", img_src);
  if(typeof Product__Gallery2 !== "undefined")
  {
  if ($(Product__Gallery2).hasClass("slick-initialized")) {
    $(Product__Gallery2).slick("refresh");
  }  
  }
  
}

function handleProductsChange(product_type, selector, index, pindex) {
  document.dispatchEvent(new CustomEvent("configurator-image-update"));
  var selectedTitle;
  if (product_type == "case") {
    selectedTitle = mobile_bundle_products.case[index].title;
  } else {
    selectedTitle = mobile_bundle_products.straps[index].title;
    var lbl = document.getElementById("titleLabel");
    lbl.style.display = "none";
  }

  updateImage(product_type, index);

  //  var newPrice = mobile_bundle_products_selected.case.price + mobile_bundle_products_selected.straps.price;
  // newPrice = parseFloat(newPrice);
  // document.querySelectorAll('.ProductMeta__Price.Price').forEach(function(e){ e.innerText = '€__'.replace('__', (newPrice/100).toFixed(2)); });

  if (document.querySelector(".ProductForm__Error") != null)
    document.querySelectorAll(".ProductForm__Error").forEach(function (e) {
      e.remove();
    });

  document.querySelector('[data-selected="' + selector + '"').innerText =
    selectedTitle;
  document
    .querySelector('[data-selected="' + selector + '"')
    .classList.remove("unselect");

  var model = document.querySelector(".model-select select").value;

  checkAvailability(model);
  updateTotal();
  
}

//handle   products selection
var func_closures = [];
for (var i = 0; i < product_selections.length; i++) {
  func_closures[i] = (function (index) {
    return function () {
      var current_selector = product_selections[index];

      //each product radion selections group
      var radio_group = document.querySelectorAll(
        'input[name="' + current_selector + '"]'
      );
      for (var j = 0; j < radio_group.length; j++) {
        radio_group[j].addEventListener("change", function (e) {
          changeHandler(e, current_selector);
        });
      }
    };
  })(i);
}
for (var i = 0; i < product_selections.length; i++) {
  func_closures[i]();
}

//update total product
function updateTotal() {
  // console.log('clickttt');
  var newTotal = 0,
    compareTotal = 0;

  if (mobile_bundle_products_selected["case"] != null) {
    newTotal += mobile_bundle_products_selected["case"].variants[0].price;
    if (mobile_bundle_products_selected["case"].variants[0].compare_at_price)
      compareTotal +=
        mobile_bundle_products_selected["case"].variants[0].compare_at_price;
    else
      compareTotal += mobile_bundle_products_selected["case"].variants[0].price;
  }
  if (mobile_bundle_products_selected["straps"] != null) {
    straps_variant = mobile_bundle_products_selected.straps.variants.filter(
      function (obj) {
        return (
          obj[mobile_bundle_products_selected.color_option] ==
            mobile_bundle_products_selected.color &&
          obj[mobile_bundle_products_selected.size_option] ==
            mobile_bundle_products_selected.size
        );
      }
    )[0];
    newTotal += straps_variant.price;
    if (straps_variant.compare_at_price)
      compareTotal += straps_variant.compare_at_price;
    else compareTotal += straps_variant.price;
  }

if($('#displaycover').is(":checked"))
    {
      const productTitle =$('#product-select-').val();

      var displayCoverVersionName = "Panzerglas (2er Set) - " + productTitle;
      var displayCoverProduct = displayCoverProducts.find(
        (product) => product.title === displayCoverVersionName
      );
      // If a displaycover version of the product exists, check if the model variant is available
      if (displayCoverProduct) {
        var modelVariantExists = displayCoverProduct.variants[0].available;
        if(modelVariantExists)
        {
          newTotal += displayCoverProduct.variants[0].price;
          if (displayCoverProduct.variants[0].compare_at_price)
          {
            //compareTotal += displayCoverProduct.variants[0].compare_at_price;
            compareTotal += displayCoverProduct.variants[0].price;
          }
          else 
          {
            compareTotal += displayCoverProduct.variants[0].price;
          }
        }
      }
    }  

  document.querySelectorAll(".bundle-total").forEach(function (e) {
    e.innerText = money_format
      .replace("_money_", parseFloat(newTotal / 100).toFixed(2))
      .replace(".", ",");
  });
  document.querySelectorAll(".bundle-compareTotal").forEach(function (e) {
    e.innerText = money_format
      .replace("_money_", parseFloat(compareTotal / 100).toFixed(2))
      .replace(".", ",");
  });

  if (compareTotal != newTotal) {
    document.querySelectorAll(".bundle-total-wrapper").forEach(function (e) {
      addClass(e, "has-compare");
    });

    document
      .querySelectorAll(".bundle-total-wrapper .saving .price")
      .forEach(function (e) {
        e.innerText = money_format
          .replace(
            "_money_",
            parseFloat((compareTotal - newTotal) / 100).toFixed(2)
          )
          .replace(".", ",");
      });
  } else {
    document.querySelectorAll(".bundle-total-wrapper").forEach(function (e) {
      removeClass(e, "has-compare");
    });
  }
}

// function to update price when magsafe checkbox has been clicked
function handleMagsafeCheckboxChange() {
  // Recreate the magsafe version name
  const magsafeVersionName = mobile_bundle_products_selected[
    "case"
  ].title.replace(" - Handyhülle", " - MagSafe Handyhülle");
  const nonMagsafeProductName = magsafeVersionName.replace(
    " - MagSafe Handyhülle",
    " - Handyhülle"
  );

  // Check if the checkbox is checked
  if (this.checked) {
    // Set the price to the Magsafe variant price
    const selectedMagsafeProduct = magsafeCasesProducts.find(
      (product) => product.title === magsafeVersionName
    );
    if (selectedMagsafeProduct) {
      let magsafeProductCopy = JSON.parse(
        JSON.stringify(selectedMagsafeProduct)
      );
      mobile_bundle_products_selected["case"] = magsafeProductCopy;
    }
  } else {
    // Find the original (non-Magsafe) product from all available cases
    let originalProduct = mobile_bundle_products.case.find(
      (product) => product.title === nonMagsafeProductName
    );

    let originalProductCopy = JSON.parse(JSON.stringify(originalProduct));
    mobile_bundle_products_selected["case"] = originalProductCopy;
  }

  // Update the total price
  updateTotal();
}

// Add the event listener to the checkbox
magsafeCheckbox.addEventListener("change", handleMagsafeCheckboxChange);


// function to update price when displaycover checkbox has been clicked
function handleDisplayCoverCheckboxChange() {
  // Recreate the displaycover version name
  const displayCoverVersionName = mobile_bundle_products_selected[
    "case"
  ].title.replace(" - Handyhülle", " - Panzerglas Handyhülle");
  const nonDisplayCoverProductName = displayCoverVersionName.replace(
    " - Panzerglas Handyhülle",
    " - Handyhülle"
  );

  // Check if the checkbox is checked
  if (this.checked) {
    // Set the price to the Magsafe variant price
    const selectedDisplayCoverProduct = displayCoverProducts.find(
      (product) => product.title === displayCoverVersionName
    );
    if (selectedDisplayCoverProduct) {
      let displayCoverProductCopy = JSON.parse(
        JSON.stringify(selectedDisplayCoverProduct)
      );
      mobile_bundle_products_selected["case"] = displayCoverProductCopy;
    }
  } else {
    // Find the original (non-displaycover) product from all available cases
    let originalProduct = mobile_bundle_products.case.find(
      (product) => product.title === nonDisplayCoverProductName
    );

    let originalProductCopy = JSON.parse(JSON.stringify(originalProduct));
    mobile_bundle_products_selected["case"] = originalProductCopy;
  }


  // Update the total price
  updateTotal();  
  
  
}

// Add the event listener to the checkbox
displayCoverCheckbox.addEventListener("change", handleDisplayCoverCheckboxChange);

//handle de-select
function handleDeselect(selector) {
  var product_type = selector.split("_")[0];
  mobile_bundle_products_selected[product_type] = null;
  // document.querySelector('.swing-'+product_type +'.'+ baby_count).style.visibility='hidden';
  document.querySelector(
    'input[name="' + selector + '"]:checked'
  ).checked = false;
  document
    .querySelector('[data-selected="' + selector + '"')
    .classList.add("unselect");
  document.querySelector(".mobile-" + product_type).setAttribute("src", "");
  if (product_type == "case") {
    removeClass(document.querySelector(".Product__Wrapper2"), "case-selected");
    magsafeCheckbox.checked = false;
    displayCoverCheckbox.checked = false;
    updateImage("straps"); // handle back no case selection case
  } else {
    removeClass(
      document.querySelector(".Product__Wrapper2"),
      "straps-selected"
    );
  }
  //update price
  updateTotal();
}
var selectedTitles = document.querySelectorAll("span[data-selected]");
for (var i = 0; i < selectedTitles.length; i++) {
  selectedTitles[i].addEventListener("click", function (e) {
    e.target.classList.toggle("unselect");
    handleDeselect(e.target.getAttribute("data-selected"));
    e.stopPropagation();
  });
}

//handle color change
var color_radio_group = document.querySelectorAll(
  'input[name="color-options"]'
);

for (var j = 0; j < color_radio_group.length; j++) {
  color_radio_group[j].addEventListener("change", function (e) {
    handleColorChange(e)
  });
}

//handle size change
var color_radio_group = document.querySelectorAll('input[name="size-options"]');
for (var j = 0; j < color_radio_group.length; j++) {
  color_radio_group[j].addEventListener("change", function (e) {
    document.querySelector(".label-size-selected").innerText = e.target.value;
    mobile_bundle_products_selected.size = e.target.value;
    updateTotal();
  });
}

//handle submition
function bundleSubmit(event) {
  var model = document.querySelector(".model-select select").value;

  if (document.querySelector(".ProductForm__Error") != null) {
    document.querySelectorAll(".ProductForm__Error").forEach(function (e) {
      e.remove();
    });
  }

  checkAvailability(model);

  var items = [],
    case_variant = null,
    straps_variant = null;
  if (mobile_bundle_products_selected.case) {
    // case_variant = mobile_bundle_products_selected.case.variants.filter(
    //   function (obj) {
    //     return obj.option1 === model;
    //   }
    // )[0];
    case_variant = mobile_bundle_products_selected.case.variants.filter(
      function (obj) {
        const normalizedOption = obj.option1.replace(/\s*\(MagSafe\)\s*/g, ''); // Remove "(MagSafe)" from the option string
        return normalizedOption === model;
      }
    )[0];
    items.push({ id: case_variant.id, quantity: 1 });
    
  }

  if($('#displaycover').is(":checked"))
    {
      const productTitle =$('#product-select-').val();

      var displayCoverVersionName = "Panzerglas (2er Set) - " + productTitle;
      var displayCoverProduct = displayCoverProducts.find(
        (product) => product.title === displayCoverVersionName
      );
      // If a displaycover version of the product exists, check if the model variant is available
      if (displayCoverProduct) {
        var modelVariantExists = displayCoverProduct.variants[0].available;
        if(modelVariantExists)
        {
          items.push({ id: displayCoverProduct.variants[0].id, quantity: 1 });
        }
      }
    }

  if (mobile_bundle_products_selected.straps) {
    straps_variant = mobile_bundle_products_selected.straps.variants.filter(
      function (obj) {
        return (
          obj[mobile_bundle_products_selected.color_option] ==
            mobile_bundle_products_selected.color &&
          obj[mobile_bundle_products_selected.size_option] ==
            mobile_bundle_products_selected.size
        );
      }
    )[0];
    items.push({ id: straps_variant.id, quantity: 1 });
  }

  //    straps_variant = mobile_bundle_products_selected.straps.variants[0];

  if (
    (case_variant && !case_variant.available) ||
    (straps_variant && !straps_variant.available)
  ) {
    return;
  }

  var addToCartButton = event.target;
  addToCartButton.setAttribute("disabled", "disabled");
  console.log("items", items);

  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  fetch("/cart/add.js", {
    body: JSON.stringify({
      items: items,
    }),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));

    if (response.ok) {
      addToCartButton.removeAttribute("disabled");
      // We simply trigger an event so the mini-cart can re-render
      if ($(window).width() > 1024) {
        $("[data-cart-pc]").trigger("click");
      } else {
        $("[data-mobile-cart]").trigger("click");
      }
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement("span");
        errorMessageElement.className = "ProductForm__Error Alert Alert--error";
        errorMessageElement.innerHTML = content["description"];
        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
}

for (var i = 0; i < buttons.length; i++) {
  buttons[i].addEventListener("click", function (e) {
    bundleSubmit(e);
  });
}

//handle size selection
var model_select = document.querySelectorAll(".model-select select");
model_select[0].addEventListener("change", function (e) {
  updateURL('phoneModel', e.target.value)
  renderAvailableCases(e.target.value);
  checkAvailability(e.target.value);
});

//    Mobile Bild Fixieren

const fixieren_button = document.querySelector("#img_fixieren");
const fix_straps = document.querySelector("img.mobile-straps");
const fix_case = document.querySelector("img.mobile-case");
const fix_default = document.querySelector("img.mobile-default");
const infowrapper = document.querySelector(".Product__InfoWrapper");
const groeßersvg =
  "https://cdn.shopify.com/s/files/1/0269/4486/4310/files/shrink_101985.svg?v=1674734371";
const kleinersvg =
  "https://cdn.shopify.com/s/files/1/0269/4486/4310/files/enlarge_102020.svg?v=1674734273";
const comboimg = document.querySelector(".combo-wrapper img");

let fixiert = false;
fixieren_button.addEventListener("click", () => {
  fixiert = !fixiert;
  if (fixiert) {
    fix_default.style.maxHeight = "100%";
    fix_straps.style.maxHeight = "100%";
    fix_case.style.maxHeight = "100%";
    infowrapper.style.position = "relative";
    infowrapper.style.top = "0";
    fixieren_button.src = groeßersvg;
    comboimg.style.maxHeight = "100%";
  } else {
    fix_default.style.maxHeight = "40vh";
    fix_straps.style.maxHeight = "40vh";
    fix_case.style.maxHeight = "40vh";
    infowrapper.style.position = "sticky";
    infowrapper.style.top = "50px";
    fixieren_button.src = kleinersvg;
    comboimg.style.maxHeight = "40vh";
  }
});


$(document).ready(function(){
  updateStrapSliderImage(mobile_bundle_products_selected.color);

  var straps_size_variants = mobile_bundle_products_selected.straps.variants.filter(
    function (obj) {
      return (
        obj[mobile_bundle_products_selected.color_option] ==
          mobile_bundle_products_selected.color && obj.available
      );
    }
  );



  if (straps_size_variants.length == 1) {
    removeClass(document.querySelector(".size-optios"), "unavailable");
    addClass(
      document.querySelector(".size-optios"),
      "partial only-" +
        straps_size_variants[0][mobile_bundle_products_selected.size_option]
    );
    //select the available already ( check ) updated today
    
      $('label[for="' +
          straps_size_variants[0][mobile_bundle_products_selected.size_option] +
          '"]').parent().find('img').trigger('click');
  } else {
    document.querySelector(".size-optios").className =
      "selector-wrapper size-optios";
  }
  
});

// $('#product-select-').change(function(e){
//   var radio_group = document.querySelectorAll('input[name="case_product"]');
  
//   var displayCoverWrapper = document.querySelector(".displaycover-wrapper"); // get the checkbox wrapper
//   displayCoverWrapper.style.display = "none";
//   for (var j = 0; j < radio_group.length; j++) {
//     radio_group[j].addEventListener("change", function (e) {
//       changeHandler(e, "case_product");
//       handleShowHideDisplayCover(this.checked )
//     });
//   }
// });
//});
